import ReviewSortDialog from '@/views/dialog/ReviewSortDialog';
import ReviewPasswordDialog from '@/views/dialog/ReviewPasswordDialog';
import BrandNoticesDialog from '@/views/dialog/BrandNoticesDialog';
import ReviewPolicyDialog from '@/views/dialog/ReviewPolicyDialog';
import ReviewAskDialog from '@/views/dialog/ReviewAskDialog';
import SpamReportFormDialog from '@/views/dialog/SpamReportFormDialog';
import TheDialog from '@/layouts/TheDialog';

const DIALOG_ROUTES = [
  {
    path: '/review_sort',
    component: ReviewSortDialog
  },
  {
    path: '/:brand_code/reviews/:review_id/password',
    component: ReviewPasswordDialog
  },
  {
    path: '/:brand_code/brand_notices',
    component: BrandNoticesDialog
  },
  {
    path: '/:brand_code/review_policy',
    component: ReviewPolicyDialog
  },
  {
    path: '/:brand_code/review_ask',
    component: ReviewAskDialog
  },
  {
    path: '/:brand_code/spam_reports/new',
    component: SpamReportFormDialog
  }
];

export default DIALOG_ROUTES.map(item => {
  return {
    path: item.path,
    component: TheDialog,
    children: [
      {
        path: '',
        component: item.component
      }
    ]
  };
});
